// Bake a GROUND SHEET — CLIENT-ONLY (needs the live WebGL organism). The frame
// the engine is showing, painted at every stop of SHEET_STOPS and stacked into
// one png (lib/organism/groundLaw.ts has the why; lib/brand/groundTrue.ts is
// the server half that reads it back for a given ground).

import { SHEET_STOPS } from "../organism/groundLaw";

/** `exportPngs` is OrganismApi.exportPngs; `width` is each frame's width */
export async function bakeGroundSheet(exportPngs: (darks: number[]) => string[], width: number): Promise<HTMLCanvasElement | null> {
  const urls = exportPngs([...SHEET_STOPS]);
  if (!urls.length || urls.some((u) => !u)) return null;
  const imgs = await Promise.all(
    urls.map(
      (u) =>
        new Promise<HTMLImageElement>((ok, no) => {
          const img = new Image();
          img.onload = () => ok(img);
          img.onerror = no;
          img.src = u;
        }),
    ),
  );
  const W = Math.round(width);
  const H = Math.round(imgs[0].height * (W / imgs[0].width));
  const cv = document.createElement("canvas");
  cv.width = W;
  cv.height = H * imgs.length;
  const ctx = cv.getContext("2d")!;
  imgs.forEach((img, i) => ctx.drawImage(stepDown(img, W), 0, i * H, W, H));
  return cv;
}

/** halve until within 2× of the target, so a 2048px export lands at a few
 *  hundred px without the aliasing one big drawImage leaves on petal edges */
function stepDown(img: HTMLImageElement, W: number): CanvasImageSource {
  let src: CanvasImageSource = img;
  let w = img.width;
  let h = img.height;
  while (w / 2 >= W * 1.5) {
    w = Math.round(w / 2);
    h = Math.round(h / 2);
    const c = document.createElement("canvas");
    c.width = w;
    c.height = h;
    const cx = c.getContext("2d")!;
    cx.imageSmoothingQuality = "high";
    cx.drawImage(src, 0, 0, w, h);
    src = c;
  }
  return src;
}
